export default () => ({
  errorTrue: false,
  mobileMenuOn: false,
  entity: 'policy',
  entities: 'policies',
  currentEntity: {},
  policies: [],
  errors: {
  }
})



// WEBPACK FOOTER //
// ./src/app/auth/terms/policy/resources/data.js